<style>
	.project{
    position: relative;
    width:300px;
    height:auto;
    min-height: 1000px;
    background: #ffffff;
    float:left;
    box-shadow:0px 1px 6px rgba(153,152,155,0.16);
    border-radius:10px;
  }
  .projectTop{
    height:58px;
    width:100%;
    line-height: 58px;
    position: relative;
  }
  .projectTop span:nth-of-type(1){
    font-size:25px;
    font-family:PingFang SC;
    font-weight:400;
    height:58px;
    position: absolute;
    left:44px;
  }
  .projectTop span:nth-of-type(2){
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    height:58px;
    position: absolute;
    left:184px;
    color:rgba(81,71,231,1);
    cursor: pointer;
  }
  .projectBody{
    height:auto;
    width:100%;
    position: relative;
  }
  .noProject{
    width:100%;
    height:25px;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    line-height:25px;
    color:rgba(153,153,153,1);
    text-align: center;
    position: absolute;
    top:500px;
    left:0;
  }
</style>

<template>
<div class='project'>
  <div class='projectTop'>
    <span>工程项目</span>
    <span @click='publishProject'>发布需求</span>
  </div>
  <div class='noProject' v-show='project.length==0'>
    抢单,请前往柜柜app中
  </div>
  <div class='projectBody' v-show='project!=0'>

  </div>
</div>
</template>

<script>
	export default {
		components:{

		},
		props:[],
		data() {
			return {
        project:[],
			}
		},
		computed: {

		},
		mounted() {

		},
		methods: {
      publishProject(){
        //待修改
        this.$message({
          showClose: true,
          message: "下一版本将会发布此功能",
          type: 'warning'
        })
      }
		}
	}
</script>
